<div class="row m-0">
    <div class="col card bc-card p-0" *ngIf="model" style="margin-right: 12px;">
        <div class="row p-2 mx-5 mt-3 mb-2">
            <div class="col">
                <div class="row text-bayclub-blue">
                    <div class="col">
                        <div class="circle">
                            <app-group-classes-category-icon [category]="model.category.code"
                                [status]="model.status.code">
                            </app-group-classes-category-icon>
                        </div>
                        <strong> {{ model.category.name }}</strong>
                    </div>
                </div>
                <div class="row mt-2 text-bayclub-blue">
                    <div class="col">
                        <div class="text-uppercase">
                            <strong>{{ model.name }}</strong>
                        </div>
                    </div>
                </div>
                <div class="row text-bayclub-blue" *ngIf="isOnline">
                    <div class="col">
                        {{ 'GroupClassDetails.IsOnlineLabel' | translate }}
                        <span *ngIf="isStreamingServiceDefined">| {{ model.classOnline.streamingService.name }}</span>
                    </div>
                </div>
                <div class="row text-bayclub-blue">
                    <div class="col">
                        {{ model.club.shortName }} <span *ngIf="model.location"> | {{ model.location.name }}</span>
                    </div>
                </div>
                <div class="row text-bayclub-blue">
                    <div class="col">
                        <div>
                            {{ model.date | bcDate: 'MMM DD' }} &#64; {{ model.timeFromInMinutes | timeDisplay }} -
                            {{ model.timeToInMinutes | timeDisplay }}
                        </div>
                    </div>
                </div>
                <div class="row text-bayclub-blue">
                    <div class="col">
                        <span translate>GroupClassDetails.InstructorLabel</span>
                        <app-instructor-label [nominalInstructor]="model.instructor"
                            [substituteInstructor]="model.substituteInstructor"></app-instructor-label>
                    </div>
                </div>
                <div class="row text-bayclub-blue">
                    <div class="col">
                        <div>
                            {{ 'GroupClassDetails.BillableTimeInMinutesLabel' | translate }}{{ model.billableTimeInMinutes }}
                        </div>
                    </div>
                </div>
                <div class="row text-bayclub-blue">
                    <div class="col">
                        <div *ngIf="model.fee" translate [translateParams]="{ value: model.fee }">
                            GroupClassDetails.FeeLabel
                        </div>
                    </div>
                </div>

                <div class="row text-bayclub-blue">
                    <div class="col">
                        <div *ngIf="model.tax" translate
                            [translateParams]="{ percentage: model.taxPercentage, value: model.tax }">
                            GroupClassDetails.TaxLabel
                        </div>
                    </div>
                </div>

                <div class="row text-bayclub-blue">
                    <div class="col">
                        <div *ngIf="model.tax" translate [translateParams]="{ value: model.totalFee }">
                            GroupClassDetails.TotalFeeLabel
                        </div>
                    </div>
                </div>

                <div class="row mt-2 text-dimmed">
                    <div class="col class-description">
                        <strong translate>GroupClassDetails.DescriptionHeader</strong>
                        <p *ngIf="model.description" class="white-space-pre">{{ model.description }}</p>
                        <p class="text-greyed-out" *ngIf="!model.description" translate>General.NotSetValue</p>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <strong class="text-dimmed" translate>GroupClassDetails.SettingsHeader</strong>
                        <div class="text-bayclub-blue">
                            <span translate>GroupClassDetails.StatusText</span>
                            <strong> {{ model.status.name | lowercase }} </strong>
                            <span *ngIf="isActive()">
                                <span *ngIf="model.isBookingRequired && !model.isBookingRequiresSpecificResource"
                                    translate>GroupClassDetails.RequiredReservation</span>
                                <span *ngIf="model.isBookingRequired && model.isBookingRequiresSpecificResource"
                                    translate>GroupClassDetails.RequiredResourceReservation</span>
                                <span *ngIf="!model.isBookingRequired"
                                    translate>GroupClassDetails.NotRequiredReservation</span>
                            </span>
                        </div>
                        <div class="text-bayclub-blue">
                            <span *ngIf="isVisibleToConnect"
                                [innerHtml]="'GroupClassDetails.VisibleInConnect' | translate"></span>
                            <span *ngIf="!isVisibleToConnect"
                                [innerHtml]="'GroupClassDetails.NotVisibleInConnect' | translate"></span>
                        </div>
                        <div class="text-bayclub-blue" *ngIf="isBookingWindowApplicable">
                            {{ 'GroupClassDetails.BookingWindowIsApplicable' | translate }}
                            <span *ngIf="isBookingWindowUnitIsDays">
                                <span *ngIf="!isBookingWindowValueIsPlural"
                                    translate>GroupClassDetails.DaySingular</span>
                                <span *ngIf="isBookingWindowValueIsPlural" translate
                                    [translateParams]="{ value: model.bookingWindowValue }">GroupClassDetails.DaysPlural</span>
                            </span>
                            <span *ngIf="!isBookingWindowUnitIsDays">
                                <span *ngIf="!isBookingWindowValueIsPlural"
                                    translate>GroupClassDetails.HourSingular</span>
                                <span *ngIf="isBookingWindowValueIsPlural" translate
                                    [translateParams]="{ value: model.bookingWindowValue }">GroupClassDetails.HoursPlural</span>
                            </span>
                        </div>
                        <div class="pb-2 text-bayclub-blue" *ngIf="isRecurring">
                            <div class="row no-gutters">
                                <span [innerHtml]="'GroupClassDetails.RecurringStatusText' | translate "></span>
                            </div>
                            <div class="row no-gutters ml-3">
                                <span>- {{ model.recurringDefinition.daysOfWeek | bcWeekDays}}</span>
                            </div>
                            <div class="row no-gutters ml-3">
                                <span>- {{ model.recurringDefinition | bcRecurrenceEnds}}</span>
                            </div>
                        </div>
                        <div class="text-bayclub-blue" *ngIf="showRevenueDepartment">
                            <span [innerHtml]="'GroupClassDetails.RevenueDepartment' | translate:
                                {
                                    code: model.revenueDepartment.code,
                                    name: model.revenueDepartment.name
                                }"></span>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 attendance-row" *ngIf="canShowAttendance">
                    <div class="col">
                        <app-group-classes-attendance [model]="model"></app-group-classes-attendance>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>